import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/dropdown-menu';
import { buttonVariants } from '@Components/Button';
import { cn } from '@Utils/cn';
import { MoreHorizontal } from 'lucide-react';
import UserRoleDialog from './userRoleDialog';
import UserRoleForm from './userRoleForm';

const UserRoleMenu = ({ data }) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className={cn(
          buttonVariants({
            variant: 'outline',
            size: 'icon',
          }),
        )}
      >
        <MoreHorizontal size={16} />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem asChild>
          <UserRoleForm edit data={data} />
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild>
          <UserRoleDialog data={data} />
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default UserRoleMenu;
